// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TbUtils15 from "./TbUtils15.bs.js";
import * as TeamPlannerHex15 from "./TeamPlannerHex15.bs.js";

function HexPreview15(Props) {
  var unitId = Props.unitId;
  var unitItems = Props.unitItems;
  var starLevel = Props.starLevel;
  var traitCounts = Props.traitCounts;
  var exaltedUnits = Props.exaltedUnits;
  var modifier = Props.modifier;
  return React.createElement("g", {
              transform: "translate(3, 0)"
            }, React.createElement("g", {
                  className: "scale-50 sm:scale-100"
                }, React.createElement(TeamPlannerHex15.Unit.make, {
                      isDragging: false,
                      hexSize: 50,
                      hex: {
                        unit: TbUtils15.Content.decodeStr(unitId),
                        items: unitItems,
                        starLevel: starLevel,
                        chosenTrait: 0,
                        modifier: modifier
                      },
                      colNum: 0,
                      rowNum: 0,
                      onRemove: (function (param) {
                          
                        }),
                      onRemoveItem: (function (param, param$1, param$2) {
                          
                        }),
                      onUpdateHex: (function (param, param$1, param$2) {
                          
                        }),
                      onToggleMech: (function (param, param$1, param$2) {
                          
                        }),
                      traitCounts: traitCounts,
                      exaltedUnits: exaltedUnits
                    })));
}

var make = React.memo(HexPreview15);

export {
  make ,
  
}
/* make Not a pure module */
